import { Stack } from 'expo-router';
import rdcStrings from 'features/rdc/rdcStrings.en';
import { TFunction } from 'i18next';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

interface DepositCheckErrorViewProps {
  title: string;
  message: string;
  translatedText: TFunction<'rdc', undefined>;
  handleRetryAction: () => void;
  handleDoneAction: () => void;
}

const DepositCheckErrorView = ({
  title,
  message,
  translatedText,
  handleRetryAction,
  handleDoneAction,
}: DepositCheckErrorViewProps) => {
  const { outcome } = rdcStrings;

  useViewDidFocusScreenAnalyticsEvent({
    key: 'checkDepositFlowFailed',
  });

  return (
    <View style={baseStyles.container} accessible>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={title}
        messageBody={message}
        primaryButton={{
          title: translatedText(
            'error.buttons.retry',
            outcome.error.buttons.retry,
          ),
          onPress: handleRetryAction,
        }}
        secondaryButton={{
          title: translatedText(
            'error.buttons.cancel',
            outcome.error.buttons.cancel,
          ),
          onPress: handleDoneAction,
        }}
      />
    </View>
  );
};

const baseStyles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default DepositCheckErrorView;
